<script lang="ts" setup>
import type { RouteLocationGeneric } from '#vue-router'
import { IconSave, IconBell, IconStar, IconProfile, IconReceipt, IconBox, IconAddress, IconVerify, IconBack, IconCreditCard, IconReorder } from '#components'

const t2 = useT2({
  'Quick Reorder': 'Pakartotinis užsakymas',
  Quotes: 'Pasiūlymai',
  Orders: 'Užsakymai',
  'Addresses & Lockers': 'Adresai ir paštomatai',
  Profile: 'Profilis',
  'Notification Subscriptions': 'Pranešimų prenumeratos',
  'Reviews & Questions': 'Atsiliepimai ir klausimai',
  Returns: 'Grąžinimai',
  'Saved Payment Methods': 'Išsaugoti mokėjimo būdai',
  'B2B profile': 'B2B profilis',
})

// const messagesTo = 'user-messages'

type UserLink = { txt: stringI18n; to: RouteLocationGeneric; icon?: VueComponent; skip?: boolean; count?: number }
const { myLink } = useLinks()

const notifications = useBuyerNotficationCount()

const b2b = useAuth()

const b2bLink = computed((): UserLink[] => {
  if (!b2b.value.isB2B) return []
  return [
    {
      txt: t2('B2B profile'),
      to: myLink('user-b2b', {}),
      icon: IconVerify,
    },
  ]
})

const userLinks = computed((): UserLink[] => {
  const noti = notifications.value

  return [
    { txt: t2('Orders'), to: myLink('user-orders', {}), icon: IconBox, count: noti.payments },
    { txt: t2('Quick Reorder'), to: myLink('user-reorder', {}), icon: IconReorder },
    { txt: t2('Quotes'), to: myLink('user-quote', {}), icon: IconReceipt, count: noti.quote },
    { txt: t2('Returns'), to: myLink('user-returns', {}), icon: IconBack },
    // { txt: t2('Upcoming entries'), to: myLink('user-upcoming', {}), icon: IconClock },
    // { txt: t2('Gift cards'), to: myLink('user-gift', {}), icon: IconGiftcard },
    // { txt: t2('Messages'), to: myLink(messagesTo, {}), icon: IconChat },
    { txt: t2('Notification Subscriptions'), to: myLink('user-subscriptions', {}), icon: IconBell },
    { txt: t2('Save lists'), to: myLink('user-saved', {}), icon: IconSave },
    {
      txt: t2('Reviews & Questions'),
      to: myLink('user-posts-index-type', { type: 'reviews' }),
      icon: IconStar,
      count: noti.toReview,
    },
    { txt: t2('Saved Payment Methods'), to: myLink('user-cards', {}), icon: IconCreditCard },
    { txt: t2('Addresses & Lockers'), to: myLink('user-address', {}), icon: IconAddress },
    { txt: t2('Profile'), to: myLink('user-profile', {}), icon: IconProfile },
    ...b2bLink.value,
  ] satisfies UserLink[]
})

const routeName = useParams((_, route) => myLinkName(route))
</script>

<template>
  <BuyerProfile class="_pb4" />

  <div class="_col _gap02">
    <LinkTablet v-for="item in userLinks" :key="myLinkName(item.to)" :to="item.to" :txt="item.txt" :active="!!routeName?.startsWith(myLinkName(item.to) || '')">
      <component :is="item.icon" class="_svg18" />
      <template v-if="item.count" #after>
        <span class="_br99 _ml1 _bg5 _c1 _svg20 _lh1 _ctr _fs07 _fw-xl">{{ item.count }}</span>
      </template>
    </LinkTablet>
  </div>
</template>
